<template>
  <div class="pfooter" >
    <div class="footerConter">
      <div class="footerTop">
        <div>
          <img :src="hrefurl+'/public/footer_home/footerLogo.png'" alt="logo"/>
        </div>
        <div>
        <img :src="hrefurl+'/public/footer_home/footerContact.png'" />
        </div>
      </div>
      <div class="footerBottom">
        <p><span style="font-family:Arial">Copyright © 2020 cippe.com.cn All Rights Reserved</span> by ZHENWEI EXPO（SC: 834316）</p>
        <p><span class="record" @click="webHerf('https://beian.miit.gov.cn')">京ICP备05086866号</span></p>
      </div>
    </div> 
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .pfooter{
    width: 100%;
    height: 200px;
    background-color: #373737;
  }
  .footerConter{
    width: 100%;
    max-width: 1200px;
    height: 200px;
    background-color: #373737;
    margin: 0 auto;
    padding: 0 10px;
    /* background-color: tomato; */
  }
  .footerTop{
    display: flex;
    justify-content: space-between;
  }
  .footerTop>div{
    padding: 30px 0;
  }
  .footerBottom>p{
    font-size: 14px;
    color: whitesmoke;
    padding-bottom: 15px;
  }
  .record{
    cursor: pointer;
  }
  .record:hover{
    text-decoration: underline;
  }
</style>